import {
    ApartmentBuildingModel,
    AreaProjectModel,
    ConstructionNumberModel,
    DistrictModel,
    ProjectPhaseModel,
    PropertyTypeModel,
} from '../generated';

const filterApiObjects = <
    ApiObject extends object,
    Conditions extends Partial<ApiObject> = Partial<ApiObject>,
>() => {
    return <T extends ApiObject = ApiObject>(objects: T[], conditions: Conditions): T[] =>
        objects.filter((object) => {
            const match: boolean[] = [];

            (Object.keys(conditions) as (keyof T)[]).forEach((key) => {
                // the following line looks much more sane in newer versions of typescript :(
                const condition = conditions[key as any as keyof Conditions] as any;
                if (condition === null || condition === undefined) return;

                const conditionMatches = object[key] === condition;
                match.push(conditionMatches);
            });

            return match.indexOf(false) === -1;
        });
};

const findApiObject = <
    ApiObject extends object,
    Conditions extends Partial<ApiObject> = Partial<ApiObject>,
>() => {
    return <T extends ApiObject = ApiObject>(objects: T[], conditions: Conditions): T | undefined =>
        objects.find((object) => {
            const match: boolean[] = [];

            (Object.keys(conditions) as (keyof T)[]).forEach((key) => {
                // the following line looks much more sane in newer versions of typescript :(
                const condition = conditions[key as any as keyof Conditions] as any;
                if (condition === null || condition === undefined) return;

                const conditionMatches = object[key] === condition;
                match.push(conditionMatches);
            });

            return match.indexOf(false) === -1;
        });
};

const filterConstructionNumbers = filterApiObjects<ConstructionNumberModel>();
const filterPropertyTypes = filterApiObjects<PropertyTypeModel>();
const filterProjectPhases = filterApiObjects<ProjectPhaseModel>();
const filterDistricts = filterApiObjects<DistrictModel>();
const filterAreaProjects = filterApiObjects<AreaProjectModel>();
const filterApartmentBuildings = filterApiObjects<ApartmentBuildingModel>();

const findConstructionNumber = findApiObject<ConstructionNumberModel>();
const findPropertyType = findApiObject<PropertyTypeModel>();
const findProjectPhase = findApiObject<ProjectPhaseModel>();
const findDistrict = findApiObject<DistrictModel>();
const findAreaProject = findApiObject<AreaProjectModel>();
const findApartmentBuilding = findApiObject<ApartmentBuildingModel>();

export {
    filterConstructionNumbers,
    filterPropertyTypes,
    filterProjectPhases,
    filterDistricts,
    filterAreaProjects,
    filterApartmentBuildings,
    findConstructionNumber,
    findPropertyType,
    findProjectPhase,
    findDistrict,
    findAreaProject,
    findApartmentBuilding,
};
